import { TenantBaseApi } from "api/TenantSlug/TenantBaseApi.ts";

import GetIntegrationCustomFieldsResponse = App.Http.Responses.Integration.GetIntegrationCustomFieldsResponse;
import GetIntegrationCustomFieldResponse = App.Http.Responses.Integration.GetIntegrationCustomFieldResponse;
import UpdateIntegrationCustomFieldRequest = App.Http.Requests.Integration.UpdateIntegrationCustomFieldRequest;

class IntegrationCustomFieldApi extends TenantBaseApi {
    /**
     * Get list of custom fields for a specific integration
     *
     * - Request: None
     * - Response: GetIntegrationCustomFieldsResponse
     */
    async index(integrationId: string): Promise<GetIntegrationCustomFieldsResponse> {
        return await this.get<GetIntegrationCustomFieldsResponse, null>(`/integrations/${integrationId}/custom-fields`);
    }

    /**
     * Get specific custom field for a specific integration
     *
     * - Request: { integrationId: string, customFieldId: string }
     * - Response: GetIntegrationCustomFieldResponse
     */
    async show(integrationId: string, customFieldId: string): Promise<GetIntegrationCustomFieldResponse> {
        return await this.get<GetIntegrationCustomFieldResponse, null>(
            `/integrations/${integrationId}/custom-fields/${customFieldId}`
        );
    }

    /**
     * Store new custom field for a specific integration
     *
     * - Request: StoreIntegrationCustomFieldData
     * - Response: GetIntegrationCustomFieldResponse
     */
    async store(
        integrationId: string,
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore - types from BE
        request: StoreIntegrationCustomFieldData
    ): Promise<GetIntegrationCustomFieldResponse> {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore - types from BE
        return await this.post<GetIntegrationCustomFieldResponse, StoreIntegrationCustomFieldData>(
            `/integrations/${integrationId}/custom-fields`,
            request
        );
    }

    /**
     * Update existing custom field using PUT
     *
     * - Request: StoreIntegrationCustomFieldData
     * - Response: GetIntegrationCustomFieldResponse
     */
    async update(
        integrationId: string,
        customFieldId: string,
        request: UpdateIntegrationCustomFieldRequest
    ): Promise<GetIntegrationCustomFieldResponse> {
        return await this.put<GetIntegrationCustomFieldResponse, UpdateIntegrationCustomFieldRequest>(
            `/integrations/${integrationId}/custom-fields/${customFieldId}`,
            request
        );
    }

    /**
     * Delete a specific custom field for a specific integration
     *
     * - Request: { integrationId: string, customFieldId: string }
     * - Response: void
     */
    async destroy(integrationId: string, customFieldId: string): Promise<void> {
        return await this.delete<void>(`/integrations/${integrationId}/custom-fields/${customFieldId}`);
    }
}

export const integrationCustomFieldApi = new IntegrationCustomFieldApi();
